var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#666766;}\n\t.st2{fill:\"currentColor\";}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st1",
    width: 800,
    height: 800
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M410.8,183.5h-21.4c-2,0-3.5-1.6-3.5-3.5V42.3c0-2,1.6-3.5,3.5-3.5h21.4c2,0,3.5,1.6,3.5,3.5v137.6 C414.3,181.9,412.8,183.5,410.8,183.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M471,105.3v29.1c115.7,31.2,200.8,136.9,200.8,262.4c0,150.1-121.7,271.8-271.8,271.8S128.2,547,128.2,396.8 c0-125.4,84.9-230.9,200.3-262.3v-29.1C197.3,137.5,100,255.8,100,396.8c0,165.7,134.3,300,300,300s300-134.3,300-300 C700,255.6,602.4,137.2,471,105.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M553.9,555c-22.3,22.3-38.1,29.7-38.1,29.7c-10.7,5.2-23.5,2.8-32.1-12.6c-8.6-15.4-22.2-51.6-24.9-61.2 c-2.7-9.6,0.5-16.8,9.1-25.1c5-5,8.4-8.4,8.4-8.4s3.5-3.5,8.4-8.4c8.3-8.6,15.5-11.8,25.1-9.1s45.8,16.4,61.2,24.9 s17.8,21.4,12.6,32.1C583.6,516.9,576.4,532.5,553.9,555z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M246.3,247.5c-22.3,22.3-29.7,38.1-29.7,38.1c-5.2,10.7-2.8,23.5,12.6,32.1s51.6,22.2,61.2,24.9 c9.6,2.7,16.8-0.5,25.1-9.1c5-5,8.4-8.4,8.4-8.4s3.5-3.5,8.4-8.4c8.6-8.3,11.8-15.5,9.1-25.1c-2.7-9.6-16.4-45.8-24.9-61.2 c-8.6-15.4-21.4-17.8-32.1-12.6C284.5,217.8,268.8,225,246.3,247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M553.7,247.1c22.3,22.3,29.7,38.1,29.7,38.1c5.2,10.7,2.8,23.5-12.6,32.1c-15.4,8.6-51.6,22.2-61.2,24.9 c-9.6,2.7-16.8-0.5-25.1-9.1c-5-5-8.4-8.4-8.4-8.4s-3.5-3.5-8.4-8.4c-8.6-8.3-11.8-15.5-9.1-25.1c2.7-9.6,16.4-45.8,24.9-61.2 c8.6-15.4,21.4-17.8,32.1-12.6C515.5,217.4,531.2,224.6,553.7,247.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M246.1,554.6c22.3,22.3,38.1,29.7,38.1,29.7c10.7,5.2,23.5,2.8,32.1-12.6c8.6-15.4,22.2-51.6,24.9-61.2 c2.7-9.6-0.5-16.8-9.1-25.1c-5-5-8.4-8.4-8.4-8.4s-3.5-3.5-8.4-8.4c-8.3-8.6-15.5-11.8-25.1-9.1s-45.8,16.4-61.2,24.9 s-17.8,21.4-12.6,32.1C216.4,516.5,223.6,532.1,246.1,554.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 400,
    cy: 401.1,
    r: 70.9
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.08257ed63bc45f7f126edaf0787a6d56.svg";
export { ForwardRef as ReactComponent };